import { endpoints } from 'src/utils';
import { createListHook } from 'src/actions/utils/create-action';

/**
 * Hook to fetch brands for the current user's accessible stores
 * @param {Object} args - Fetch arguments (params, config, etc.)
 * @returns {Object} { data, loading, error, validating, empty, refresh }
 */
export const useGetMyBrands = createListHook(endpoints.me.brands);
